import React, { useEffect } from "react";
import "./dashboard.css";
import BasicTable from "./active-course";
import UserData from "../../components/userLoged/userData";
import AddButton from "../../components/buttons/addButton";
import { Link } from "react-router-dom";
import ContentMgmt from "./contentMgmt";
import BatchAllocation from "./BatchAllocation";
import { DefaultReduxState } from "../../store"
// import AddCourse from "../../components/addNewCourse/addCourse";
import { useSelector } from "react-redux";
// import { store } from "../../store";

export default function DashBoard() {
  const user = useSelector((state: DefaultReduxState) => state.auth);

  return (
    <>
      <div className="active-courses">
        <div className="options">
          <h1>Active Courses</h1>
          {/* <AddButton /> */}
        </div>
        <BasicTable />
      </div>
      <div className="down-tables-dashboard  d-flex justify-content-between mt-4">
        <ContentMgmt />
        <BatchAllocation />
      </div>
    </>
  );
}
